export const imports = {
  'getting-started.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "getting-started" */ 'getting-started.mdx'
    ),
  'preseted-themes.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "preseted-themes" */ 'preseted-themes.mdx'
    ),
  'theme-config.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "theme-config" */ 'theme-config.mdx'
    ),
}
